// components/editor/tools.js
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Quote from "@editorjs/quote";
import Delimiter from "@editorjs/delimiter";
import ImageTool from "@editorjs/image";
import api from "../../api";

const image = {
  class: ImageTool,
  config: {
    uploader: {
      uploadByFile: async (file) => {
        const formData = new FormData();
        formData.append("image", file);
        const res = await api.upload_image(formData);
        if (res?.status === 201)
          return { success: 1, file: { url: res.data.url } };
        return { success: 0 };
      },
      uploadByUrl: async (url) => ({ success: 1, file: { url } }),
    },
  },
};

export function getTools(preset = "full") {
  const basic = {
    list: { class: List, inlineToolbar: true },
  };

  if (preset === "basic") return basic;

  return {
    header: { class: Header, inlineToolbar: true },
    ...basic,
    quote: { class: Quote, inlineToolbar: true },
    delimiter: Delimiter,
    image,
  };
}
